module.exports = __webpack_public_path__ + "static/media/rawalpindi.e1e4e596.svg";